module.exports = __webpack_public_path__ + "c5ef91bda71bb17d71acb825c7f22360.jpg";